/* cobra-modelos.js — busca instantânea no índice de modelos do fabricante.
   Filtra os chips por texto (ignora acento e caixa); esconde o rótulo do grupo que ficou
   vazio e mostra o aviso de "nada encontrado". Sem dependência. */
(function () {
  var norm = function (s) {
    return (s || '')
      .normalize('NFD')
      .replace(/\p{Diacritic}/gu, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  };

  function liga(raiz) {
    var busca = raiz.querySelector('[data-cobra-modelos-busca]');
    if (!busca || busca.dataset.ligado) return;
    busca.dataset.ligado = '1';

    var chips = Array.prototype.slice.call(raiz.querySelectorAll('.cobra-modelo'));
    var secoes = Array.prototype.slice.call(raiz.querySelectorAll('[data-cobra-modelos-secao]'));
    var vazio = raiz.querySelector('[data-cobra-modelos-vazio]');

    chips.forEach(function (c) {
      c.dataset.busca = norm(c.dataset.nome || c.textContent);
    });

    busca.addEventListener('input', function () {
      var termo = norm(busca.value);
      var achou = 0;

      chips.forEach(function (c) {
        var ok = !termo || c.dataset.busca.indexOf(termo) !== -1;
        c.hidden = !ok;
        if (ok) achou++;
      });

      secoes.forEach(function (s) {
        s.hidden = s.querySelectorAll('.cobra-modelo:not([hidden])').length === 0;
      });

      if (vazio) vazio.hidden = achou !== 0;
    });
  }

  function iniciar(escopo) {
    (escopo || document).querySelectorAll('[data-cobra-modelos]').forEach(liga);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', function () { iniciar(); });

  // editor de temas: seção recarregada
  document.addEventListener('shopify:section:load', function (e) { iniciar(e.target); });
})();
